<template>
  <section class="business-profile-section">
    <div class="container business-profile-shell">
      <div class="business-layout">
        <div class="portfolio-copy">
          <div class="copy-panel">
            <h1 class="business-profile-title">
              <b>{{ $t('businessProfile.title') }}</b>
            </h1>
            <div class="title-rule"></div>
            <p class="business-profile-lead">{{ $t('businessProfile.subtitle') }}</p>

            <div class="facility-list">
              <article class="facility-card facility-primary">
                <span class="facility-index">01</span>
                <p>
                  <b>{{ $t('businessProfile.fasilitas.item1') }}</b>
                </p>
              </article>

              <article class="facility-card facility-secondary">
                <span class="facility-index">02</span>
                <p>{{ $t('businessProfile.fasilitas.item2') }}</p>
              </article>
            </div>
          </div>
        </div>

        <div class="portfolio-visuals">
          <button
            type="button"
            class="asset-card asset-card-ggcp"
            data-bs-toggle="modal"
            data-bs-target="#ggcp"
          >
            <img class="img-fluid" src="../assets/pabrik/GGCP/ggcp4.jpg" alt="Gresik Gas Cogeneration Plant" />
            <div class="asset-content">
              <span class="asset-code">GGCP</span>
              <h3>Gresik Gas Cogeneration Plant</h3>
            </div>
          </button>

          <button
            type="button"
            class="asset-card asset-card-kdm"
            data-bs-toggle="modal"
            data-bs-target="#kdm"
          >
            <img class="img-fluid" src="../assets/pabrik/KDM/kdm2.jpg" alt="PT Kaltim Daya Mandiri" />
            <div class="asset-content">
              <span class="asset-code">KDM</span>
              <h3>PT Kaltim Daya Mandiri</h3>
            </div>
          </button>
        </div>
      </div>
    </div>

    <div class="modal fade" id="ggcp" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <img class="img-fluid" src="../assets/pabrik/GGCP/Skema Porto GGCP.jpg" alt="Skema Porto GGCP" />
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="kdm" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <img class="img-fluid" src="../assets/pabrik/KDM/Skema Porto KDM.jpg" alt="Skema Porto KDM" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BusinessProfile',
}
</script>

<style scoped>
.business-profile-section {
  position: relative;
  overflow: hidden;
  padding: clamp(4rem, 7vw, 6rem) 0;
  background-image:
    linear-gradient(135deg, rgba(7, 14, 30, 0.95), rgba(7, 14, 30, 0.72)),
    url("../assets/pabrik/GGCP/ggcp1.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}

.business-profile-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at top left, rgba(11, 84, 145, 0.28), transparent 38%),
    radial-gradient(circle at bottom right, rgba(28, 151, 121, 0.26), transparent 34%);
  pointer-events: none;
}

.business-profile-shell {
  position: relative;
  z-index: 1;
}

.business-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  gap: clamp(1.5rem, 3vw, 3rem);
  align-items: center;
}

.copy-panel {
  position: relative;
  padding: clamp(1.75rem, 3vw, 2.75rem);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 32px;
  background:
    linear-gradient(180deg, rgba(8, 17, 36, 0.86), rgba(8, 17, 36, 0.58));
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(10px);
}

.copy-panel::after {
  content: "";
  position: absolute;
  inset: auto 24px 18px auto;
  width: 96px;
  height: 96px;
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.12), transparent);
  pointer-events: none;
}

.business-profile-title {
  margin: 0;
  max-width: 8ch;
  color: #ffffff;
  font-size: clamp(2.75rem, 5.1vw, 5.4rem);
  line-height: 0.94;
}

.title-rule {
  width: 104px;
  height: 5px;
  margin: 1.5rem 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #f17a37, #0b76bf 60%, #29a26f);
}

.business-profile-lead {
  margin: 0 0 1.5rem;
  max-width: 56ch;
  color: rgba(255, 255, 255, 0.88);
  font-size: clamp(1rem, 1.3vw, 1.2rem);
  line-height: 1.8;
}

.facility-list {
  display: grid;
  gap: 1rem;
}

.facility-card {
  position: relative;
  padding: 1.2rem 1.2rem 1.2rem 4.25rem;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.facility-card p {
  margin: 0;
  color: rgba(255, 255, 255, 0.92);
  font-size: 1.03rem;
  line-height: 1.75;
}

.facility-index {
  position: absolute;
  top: 1rem;
  left: 1rem;
  display: grid;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 14px;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.facility-primary .facility-index {
  background: linear-gradient(135deg, #f17a37, #d95a18);
}

.facility-secondary .facility-index {
  background: linear-gradient(135deg, #2c9b74, #0f6f7c);
}

.portfolio-visuals {
  display: grid;
  gap: 1.25rem;
}

.asset-card {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 285px;
  padding: 0;
  border: 0;
  border-radius: 30px;
  background: #101626;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}

.asset-card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
}

.asset-card-ggcp::before {
  background: linear-gradient(135deg, rgba(241, 122, 55, 0.58), rgba(15, 17, 34, 0.16) 56%, rgba(15, 17, 34, 0.78));
}

.asset-card-kdm::before {
  background: linear-gradient(135deg, rgba(26, 160, 129, 0.55), rgba(14, 19, 36, 0.14) 56%, rgba(14, 19, 36, 0.82));
}

.asset-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.02);
  transition: transform 0.55s ease;
}

.asset-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 36px 70px rgba(0, 0, 0, 0.36);
}

.asset-card:hover img {
  transform: scale(1.08);
}

.asset-content {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  padding: 1.5rem;
}

.asset-code {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 0.8rem;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 999px;
  background: rgba(8, 17, 36, 0.28);
  color: #ffffff;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.asset-card h3 {
  margin: 0.95rem 0 0;
  max-width: 14ch;
  color: #ffffff;
  font-size: clamp(1.55rem, 2.1vw, 2.2rem);
  line-height: 1.06;
  text-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
}

.modal-content {
  border: 0;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 36px 80px rgba(0, 0, 0, 0.3);
}

.modal-body {
  padding: 0;
  background: #0a1223;
}

@media (max-width: 991px) {
  .business-profile-section {
    background-attachment: scroll;
  }

  .business-layout {
    grid-template-columns: 1fr;
  }

  .business-profile-title {
    max-width: 10ch;
  }

}

@media (max-width: 767px) {
  .business-profile-section {
    padding: 3.5rem 0;
  }

  .copy-panel {
    border-radius: 26px;
  }

  .business-profile-title {
    font-size: clamp(2.4rem, 10vw, 3.5rem);
  }

  .facility-card {
    padding: 1.05rem 1rem 1.05rem 3.7rem;
  }

  .facility-card p {
    font-size: 0.98rem;
    line-height: 1.65;
  }

  .asset-card {
    min-height: 240px;
    border-radius: 24px;
  }

  .asset-content {
    padding: 1.15rem;
  }

  .asset-card h3 {
    max-width: none;
    font-size: 1.45rem;
  }
}
</style>
